<template>
  <div class="main">
    <my-nav-bar title="话题" :textColor="textColor" :background="background"  :borderd="true"></my-nav-bar>
    <!-- 热议话题 -->
    <div class="hot-topic">
      <div class="header">
        <div class="title">热议话题</div>
        <div class="look-all" @click="openDownModal">
          查看全部
          <div class="icon">
            <span class="iconfont icon-jiantouyou"></span>
          </div>
        </div>
      </div>
      <div class="topic-list">
        <div class="item" v-for="(item, index) in topics" :key="index" @click="jumpTopoic(item.id)">
          <p class="title ellipsis"># {{ item.title }}</p>
          <p class="subtitle ">{{ item.join_num }}人参与{{item.post_num}}篇帖子</p>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="tabs">
        <div
          :class="{ item: true, active: index == current }"
          v-for="(item, index) in tabs"
          @click="changeTab(index)"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="list">
        <post-card
          v-for="(item, index) in list"
          :key="index"
          :dataSource="item"
          :audio="audio"
        ></post-card>
      </div>
    </div>
    <div class="loading">
      <van-loading type="spinner" size="16" v-if="!finished">加载更多...</van-loading>
      <span v-else class="no-more">没有更多了</span>
    </div>
    <img class="sendTopic" src="@/assets/img/sendTopic.png" @click="openDownModal" alt="">
  </div>
</template>
<script>
import MyNavBar from "@/components/MyNavBar.vue";
import PostCard from "@/components/PostCard.vue";
import { getNewPostList, getHotListpush,gettopicsApi } from "@/request/api.js";
import { Loading, Toast } from "vant";
export default {
  data() {
    return {
        background:"#fff",
        textColor:"#222",
      topics: [],
      tabs: [
        { type: 1, name: "最新" },
        { type: 2, name: "最热" },
      ],
      filters: {
        page: 1,
        pcount: 10,
      },
      current: 0,
      list: [],
      isLoading: false,
      finished: false,
        audio: null
    };
  },
  components: {
    MyNavBar,
    PostCard,
    [Loading.name]: Loading,
  },
  mounted() {
    this.initScroll();
    this.loadNewPostList();
    this.initGetTopic();//获取话题列表
      this.audio = document.createElement("AUDIO")
      document.body.append(this.audio)
  },
  methods: {
    changeTab(index) {
    // 清空状态
      this.filters.page = 1;
      this.finished = false;
      this.list = []
      this.current = index;
      this.loadData();
    },
    loadData() {
      if (this.current == 0) {
        this.loadNewPostList();
      } else if (this.current == 1) {
        this.$nextTick(() => {
          this.loadHotList();
        });
      }
    },
    //获取话题列表
    initGetTopic(){
        gettopicsApi().then(res=>{
            if(res.error_code == 0){
                console.log(res);
                this.topics = res.data
            }
        })
    },
    //获取最新话题
    loadNewPostList() {
      if (this.isLoading) return;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.isLoading = true;
      getNewPostList(this.filters)
        .then((res) => {
          if (res.error_code == 0) {
            this.isLoading = false;
            this.finished = res.posts.length < this.filters.pcount
              if(this.filters.page > 1){
                  this.list.push(...res.posts);
              }else{
                  this.list = res.posts;
              }
          }
          Toast.clear();
        })
        .catch((err) => {
        });
      // setTimeout(() => {
      //     let tmpArr = this.list;
      //     this.list = [...this.list, ...tmpArr];
      //     this.isLoading = false;
      //     Toast.clear();
      // }, 1000);
    },
    //获取最热话题
    loadHotList() {
      if (this.isLoading) return;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.isLoading = true;
      getHotListpush(this.filters).then((res) => {
        if (res.error_code == 0) {
          this.isLoading = false;
          this.finished = res.data.length < this.filters.pcount;
          if(this.filters.page > 1){
              this.list = res.data
          }else{
              this.list.push(...res.data)
          }
        }
        Toast.clear();
      });
    },
    jumpTopoic(id){
        // console.log(id);
        this.$router.push({ path:'topicDetail',query:{id:id} })
    },
    // 下拉刷新事件
    initScroll() {
      let el = document.getElementsByClassName("loading")[0];
      let height = window.innerHeight;

      window.addEventListener(
        "scroll",
        () => {
          let offset = window.pageYOffset;

          // 触发刷新
          if (height + offset > el.offsetTop) {
            if ((!this.isLoading) && (!this.finished)) {
              this.filters.page ++;
              this.loadData();
            }
          }
        },
        false
      );
    },
  },
};
</script>
<style scoped lang="less">
.ellipsis{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}
.main {
  min-height: 100vh;
  width: 100%;
  background-color: #f8f8f8;
}
.sendTopic{
    width: 60px;
    height: 60px;
    object-fit: contain;
    position: fixed;
    right: 12px;
    bottom: 60px;
    z-index: 100;
}
.hot-topic {
  width: 100%;
  box-sizing: border-box;
  padding: 16px 20px;
  background: #fff;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    .title {
      font-size: 20px;
      font-weight: bold;
    }
    .look-all {
      display: flex;
      align-items: center;
      font-size: 12px;
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #000;
        color: #fff;
        font-size: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: scale(0.6);
      }
    }
  }
  .topic-list {
    display: grid;
    grid-template-columns: repeat(2, 47%);
    justify-content: space-between;
    .item {
      margin-bottom: 16px;
      .title {
        font-size: 14px;
        color: #222222;
      }
      .subtitle {
        font-size: 12px;
        color: #a7a7a7;
      }
    }
  }
}
.body {
  margin-top: 8px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 20px;
  padding-bottom: 0;
  .tabs {
    display: flex;
    .item {
      margin-right: 5px;
      font-size: 16px;
      color: #222222;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all linear 0.2s;
      height: 30px;
      width: 50px;
      position: relative;
    }
    .active {
      font-size: 20px;
      font-weight: bold;
    }
    .active::after {
      content: "";
      width: 50%;
      height: 4px;
      background-color: #ff4c67;
      position: absolute;
      border-radius: 100px;
      bottom: -5px;
      box-shadow: 0 2px 4px rgba(255, 197, 206, 0.6);
    }
  }
}
.list {
  margin-top: 20px;
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 5px 0;
}
.no-more{
    font-size: 12px;
    color: #7b7b7b;
}
</style>
